import React from "react";
import { ArticleType } from "..";
import { Block } from "../block";
import { Button } from "../../../components/button";
import { Html } from "../../../components/html";
import { BRIDGE_FUNCTION, OPEN_LINK } from "../../../constants/types/commands";
import { useSendCommand } from "../../../hooks/use-send-command";

export const CrcokArticleView = ({ article }: Pick<ArticleType, "article">) => {
    const [showAnswer1, setShowAnswer1] = React.useState(false);
    const [showAnswer2, setShowAnswer2] = React.useState(false);
    const [fadein, setFadein] = React.useState(false);
    const sendCommand = useSendCommand();

    React.useEffect(() => {
        setTimeout(() => setFadein(true), 500);
    }, []);

    if (!article) return null;

    const { details } = article;

    const conductPage = details!.slice(0, 8);
    const answer1 = details!.slice(8, 10);
    const answer2 = details!.slice(10);

    const acceptButton = conductPage[6] as InboxArticleButtonBlock;
    const denyButton = conductPage[7] as InboxArticleButtonBlock;
    const claimButton = answer2[2] as InboxArticleButtonBlock;

    return (
        <div className={`crcok ${fadein ? "fadein" : ""}`}>
            <div className="conduct paper">
                {conductPage.slice(0, 6).map((block, index) => (
                    <Block key={index} {...block} />
                ))}
            </div>
            <div className="buttons">
                <Button
                    animationSize="large"
                    variant={acceptButton.variant}
                    onClick={() => setShowAnswer1(true)}
                >
                    <div className={`label`}>{acceptButton.label}</div>
                </Button>
                <Button
                    animationSize="large"
                    variant={denyButton.variant}
                    onClick={() => setShowAnswer2(true)}
                >
                    <div className={`label`}>{denyButton.label}</div>
                </Button>
            </div>

            <div className={`answer1 ${showAnswer1 ? "show" : ""}`}>
                <div className="content">
                    <Html html={(answer1[0] as InboxArticleTextBlock).body} />
                    <div className="image" />
                    <div className="buttonContainer">
                        <Button
                            animationSize="large"
                            variant={
                                (answer1[1] as InboxArticleButtonBlock).variant
                            }
                            onClick={() => setShowAnswer1(false)}
                        >
                            {(answer1[1] as InboxArticleButtonBlock).label}
                        </Button>
                    </div>
                </div>
            </div>

            <div className={`answer2 ${showAnswer2 ? "show" : ""}`}>
                <div className="content">
                    <Block {...(answer2[0] as InboxArticleBlock)} />
                    <div className="images">
                        <div className="bubble" />
                        <div className="emote" />
                    </div>
                    <Html html={(answer2[1] as InboxArticleTextBlock).body} />
                    <Button
                        animationSize="large"
                        variant={claimButton.variant}
                        onClick={() => {
                            if (!claimButton.url) {
                                sendCommand(BRIDGE_FUNCTION, {
                                    functionName: claimButton.functionName,
                                    functionArgs: claimButton.functionArgs,
                                });
                            } else {
                                sendCommand(OPEN_LINK, {
                                    url: claimButton.url,
                                    id: claimButton.id,
                                    label: "Claim Emote",
                                });
                            }
                        }}
                    >
                        {claimButton.label}
                    </Button>
                </div>
            </div>
        </div>
    );
};
